module.exports = {
  language:{
    name:'简体中文',
    title:'选择语言',
    subList:[
      {
        name:'English',
        link:'en',
      },
      // {
      //   name:'简体中文',
      //   link:'zh',
      // },
      {
          name:'繁體中文',
          link:'tw',
      },
      {
        name:'日本語',
        link:'jp',
      },
      {
        name:'한국어',
        link:'kr',
      },
      {
        name:'ไทย',
        link:'th',
      },
      {
        name:'Tiếng Việt',
        link:'vn',
      },
      {
        name:'Español',
        link:'es',
      },
    ]
  },
  "user":{//私
    "wdtd":"私のチーム",
    "wdyj":"私のパフォーマンス",
    "ren":"人",
  },
  "kjsy":{
    "title":"収益",
    "fxsy":"収益の分配",
    "zjlsl":"総報酬額:",
    "jl":"報酬",
    "sj":"日付",
    "sl":"数量",
    "sm":"説明"
  },
  "pay":{//購入
    title:'マイニングマシンを購入',
    gmsl:'購入数量',
    zf:'支払い',
    kyye:'利用可能残高',
    kyyebz:'利用可能な残高が不足しています',
    bztbtips:'入力された引き出し金額が、この通貨の最低引き出し要件を下回っています',
    bztbtips2:'引き出し額は最低引き出し額より低くすることはできません',
    qsrjymm:'6桁の取引パスワードを入力してください',
    wxts:'リマインダー',
  },
  "chongbi":{
    title:'デポジット',
    lianmc:'チェーン タイプ',
    scl:'排他チェーンの生成',
    sy:'秘密鍵',
    ewm:'QRコード',
    bcewm:'QRコードを保存',
    cbdz:'入金アドレス',
    fz:'コピー',
    sl:'入金額',
    qsrsl:'入金額を入力してください',
    sjczje:'実際の充電量',
    qsrsjczje:'実際の充電量を入力してください',
    pzms:'証明書の説明',
    qsrms:'説明を入力してください',
    hxz:'ハッシュ値',
    qsrhxz:'ハッシュ値を入力してください',
    pztp:'クーポン画像',
    qscpztp:'証明書の画像をアップロードしてください',
    fzcg:'コピー成功',
    yhkcz:'銀行カードのリチャージ',
    usdtcz:'USDT リチャージ',
    btccz:'BTC リチャージ',
    xzbz:'通貨を選択',
    sure:'確認',
    ck:'ビュー',
    "tips1": "この通貨以外の資産を上記住所に追加しないでください。資産の出金ができなくなります",
    "tips2": "1.ウォレット/プラットフォームの互換性：つまり、ネットワークがサポートされています。ターゲットプラットフォームが引き出しネットワークをサポートしていない場合、アセットを取得できません。",
    "tips3": "2.トップアップネットワークとターゲットプラットフォームは同じです。ターゲットアドレスを選択した場合はイーサリアムネットワークですが、トップアップがTRC20スマートチェーンを選択した場合、デジタル資産を取得できない可能性があります。",
    "tips4": "3.再充電する前に、住所と金額が正しいことを確認してください。",
    "tips5": "注意：ブロックネットワークの匿名性とプライバシーのため、間違った情報を入力すると、対応するアセットが失われます。充電先住所と数量をよく確認してください"
  },
  usdttb:{
    title:"コインを引き出す",
    lmc:'チェーン タイプ',
    xzl:'チェーンを選択',
    xztbdz:'引き出しアドレスを選択',
    qsrtbdz:'出金アドレスを入力してください',
    tbdz:'出金アドレス',
    qsrdz:'アドレスを入力してください',
    tbsl:'出金金額',
    tbsl2:'出金金額:',
    qsrtbsl:'出金金額を入力してください',
    sjtxje:'実際の引き出し額',
    qsrsjtxje:'実際の出金額を入力してください',
    dzje:'アカウントの金額',
    jymm:'取引パスワード',
    qsrjymm:'取引パスワードを入力してください',
    sxf:'手数料',
    qsrsxf:'手数料を入力してください',
    dzsl:'アカウントの金額',
    dzsl2:'受け取ったアカウントの金額:',
    qsrdzsl:'口座の金額を入力してください',
    wxts:'リマインダー:',
    mrzdtxcs:'毎回の最低出金額:',
    hxxf:'消費する必要があります',
    cktx:'出金のみ可能',
    ci:'回',
    wddtxyq:'出金要件を満たしていません',
    tjcg:'送信に成功しました。審査をお待ちください',
    tips:"コインを引き出すことができるのは、自分の計算能力が 1T を超える場合 (経験値マイニング マシンの計算能力を除く)、または傘下の計算能力が 50T を超える場合のみです。 ",
    dz:'アドレス',
    qd:'OK',
    "zdtb":"最低出金額"
  },
  "kefu":{
    title:'カスタマーサービスに連絡',
    zxkf:'カスタマーサービスに連絡',
    fzcg:'コピー成功'
  },
  xgdlmm:{//ログイン パスワードの変更
    title:'ログインパスワードの変更',
    t1:'現在のログインパスワード',
    t2:'現在のログインパスワードを入力してください',
    t3:'新しいパスワード',
    t4:'6～16桁の数字と文字を入力してください',
    t5:'パスワード確認',
    t6:'6～16桁の数字と文字を入力してください',
    t7:'確認',
    t8:"パスワードが確認パスワードと一致しません"
  },
  sztxmm:{//出金パスワードの設定
    title:'取引パスワードの変更',
    wjtkmm:'取引パスワードを忘れました',
    qsrjdlmm:'現在の取引パスワードを入力してください',
    en:'アカウント',
    qsryxhzsj:'メールアドレスまたは携帯電話番号を入力してください',
    t1:'現在の取引パスワード',
    t2:'新しい取引パスワード',
    t3:'6桁の取引パスワードを入力してください',
    t4:'パスワード確認',
    t5:'取引パスワードをお忘れですか? ',
    t6:'確認',
    t7:'パスワードが確認パスワードと一致しません',
    t8:'取引パスワード',
    yzm:'検証コード',
    qsryzm:'認証コードを入力してください',
    hqyzm:'認証コードを取得'
  },
  "record": {
    cbjl:'預金記録',
    tbjl:'出金記録',
    status: "['未審査','合格','却下']",
    bhly:'却下の理由',
    ldz:'アドレス:',
    cjsj:'作成時間:',
    zzsj:'転送時間:',
    czl:'リチャージ チェーン:',
    zrl:'転送チェーン:',
    jyhx:'トランザクション ハッシュ:'
  },
  yqm:{
    wdyqlj:'招待リンク',
    wdyqm:'私の招待コード',
    schbyq:'ポスター招待状の生成',
    bctp:'画像を保存',
    qx:'キャンセル',
    fx:'共有',
    yqm:'招待コードをコピー',
    bcewmdxc:'QRコードをアルバムに保存',
    bcbd:"ローカルに保存"
  },
  "wdtd":{
    title:'私のチーム',
    td:'チーム',
    yqhy:'友達を招待',
    ren:'人',
    wdtdzrs:'私のチームの総数',
    uid:'UID:',
    zh:'アカウント:',
    tdrs:'チームサイズ:',
    zcsj:'登録日:'
  },
  "wdyj":{
    title:'マイ パフォーマンス',
    wdyd:'私の世代',
    dyj:'パフォーマンス',
    tdzyj:'チームの総合成績',
    uid:'UID:',
    tdrs:'チームサイズ:',
    yj: "パフォーマンス:"
  },
  "zc":{
    title:'アセット',
    zzczh:'総資産相当額',
    dh:'交換',
    yczc:'アセットを 0 として非表示',
    xj:'現在の価格',
    zh:'変換済み',
    zcmx:'資産の詳細',
  },
  "duihuang":{
    title:"交換",
    hl:'為替レート',
    zf:'支払い',
    qbdh:'全て交換',
    ky:'利用可能',
    dd:'取得',
    ljdh:'今すぐ交換',
    cont:'為替レートは、実際に受け取った金額に応じて変わります',
    yebz:"バランスが不十分です",
    ksslbz:'利用可能な数量が不足しています',
    qtxje:'数量を入力してください',
    dhcg:'交換成功',
    mrcg:'購入成功',
    mccg:'正常に販売されました',
    wtcg:'委任が成功しました',
    ts:'プロンプト',
    btcmTips:'スマート コントラクトの設定によると、GDCC 取引所 USDT は 2023 年 8 月 8 日に開始されます。 ',
    qx:"キャンセル"
  },
  "sign": {
    "title":'サインインしてコインを受け取る',
    "title2":'毎日のサインイン報酬',
    "title3":'サインイン報酬',
    "qd":'サインイン',
    "yqd":'サインイン',
    "hdgz":'イベントルール',
    "qdjl":'チェックイン記録',
    "qdcg":'サインイン成功'
  },
  "langNew":{
    "wd": "私の",
    "jd": "借りています",
    "jghy": "先物",
    "xbsg": "シンガポール通貨購入",
    "sylx": "特典の種類",
    "syts": "収益日数: ",
    "rsy": "一日の収入: ",
    "rsy2": "毎日の収入",
    "yjdts": "借りた日数: ",
    "jdsy": "融資収入: ",
    "jdsy2": "貸付収入",
    "jdrq": "融資日: ",
    "qdsy": "サインイン特典",
    "tgsy": "プロモーション特典",
    "sybl": "利益率",
    "sybl2": "利益率: ",
    "ljcy": "今すぐ参加",
    "zsy": "総収入",
    "jdrz": "リンクノード",
    "jiedian": "ノード",
    "qsrje": "ノードを入力してください",
    "xyb": "次へ",
    "zhye": "アカウント残高",
    "dzye": "アドレスバランス",
    "zhyezh": "口座残高（相当額）",
    "zq": "ピリオド: ",
    "zq2": "ピリオド",
    "jdsl": "融資金額",
    "yxbd": "メール認証",
    "qsryxzh": "電子メール アカウントを入力してください",
    "yxgz": "入力されたメールアドレスはルールに準拠していません",
    "jxz": "進行中",
    "ywc": "完了",
    "day": "日",
    "jg": "価格: ",
    "zwsj": "データがありません~",
    "wyjb": "借りる",
    "fxjl": "シェア報酬",
    "aqsz": "セキュリティ設定",
    "wded": "私の二代目",
    "wdsd": "私の 3 世代",
    "dbxe": "単一トランザクション制限",
    "tjdd": "注文を送信",
    "tqsh": "引き換えの撤回: ",
    "shuhui": "救い",
    "ljdz": "リンクアドレス",
    "yyqh": "言語切り替え",
    "zxkf": "カスタマーサービス",
    "syl": "毎日の返品",
    "zhuanbi": "コインを稼ぐ",
    "zbsy": "通貨収入を得る",
    "mc": "名前",
    "zxj": "最新価格",
    "zfb": "上昇リスト",
    "shouye": "ホームページ",
    "gg": "お知らせ",
    "rzz": "認証中",
    "yrz": "認証済み",
    "rzsb": "認証に失敗しました。再認証してください",
    "cxrz": "再認証",
    "jymmts": "セキュリティ設定に移動して、トランザクションパスワードを設定してください。"
  },
  "xbsg":{
    "title":"コイン購入",
    "wdsg":"詳細",
    "scts":"ロックアップ日：",
    "sy":"残り",
    "ljsg":"今すぐ購読",
    "ysk":"完売",
    "xzjdy":"今すぐ購読",
    "dy":"購読",
    "fxjg":"発行価格",
    "fxl":"サーキュレーション",
    "ssrq":"上場日",
    "yxqx":"有効期間",
    "qsrsl":"数量を入力してください",
    "syl":"残り",
    "sgrq":"購入日",
    "sgsl":"額",
    "bz":"コイン",
    "yebz":"不十分なUSDTバランス",
    "tgsl":"パス数量",
    "shz":"レビュー中",
    "wtg":"合格しなかった",
    "ytg":"合格しました"
  },
  "wydb":{
    "title":"借りる",
    "db":"借りる",
    "dbz":"借りる",
    "jl":"記録",
    "jdzq":"期間（日）",
    "qhk":"返済",
    "ljdb":"累積",
    "dhkbs" :"支払い待ち",
    "jkje":"融資額",
    "qsrje":"数量を入力してください",
    "rll":"毎日の金利",
    "hkfs":"返済",
    "dqych":"期限切れ",
    "lx":"興味",
    "fkjg":"貸し手",
    "tpsc":"クレジットローン(画像アップロード)",
    "fwxx":"住宅情報",
    "srzm":"収入の証明（雇用関係）",
    "yhmx":"銀行取引明細書",
    "zjz":"身分証明書の写真",
    "yd":"私は読んで同意しました",
    "xy":"ローン契約を申請する",
    "sqdb":"ローンチェーンに申し込む",
    "gb":"閉鎖",
    "qd":"わかった",
    "ts":"ローン契約の申し込みを確認してください",
    "dbjl":"記録",
    "hkhth":"注文コード",
    "wsh":"未レビュー",
    "yfk":"ローン",
    "sqrq":"適用時間",
    "zq":"サイクル",
    "dbsl":"リブの数",
    "zhke":"支払い合計額",
    "yhkxq":"返済の詳細",
    "bqyhk":"当期の返済額(USDT)",
    "hktips":"残高が十分であることを確認してください。残高が不足している場合は、最初に再充電してから返済してください",
    "bj":"主要",
    "jie":"借りる",
    "ljhk":"すぐに返済",
    "qcz":"預け入れる",
    "yebzqxcz":"残高が不足している場合は、最初に再充電してから返済してください",
    "znj":"延滞料",
    "yqts":"延滞日数"
  },
  "hkxq":{
    "dd":"注文",
    "fzhkdz":"返済先住所をコピーする",
    "hkxq":"返済の詳細",
    "zlx":"総利息",
    "zhk":"総返済",
    "hkjg":"返済機関",
    "qschkpz":"返済証明書をアップロードしてください",
    "hkpz":"返済証明書"
  },
  "kxt":{
    "gao":"H",
    "di":"L",
    "wtgd":"保留中の注文を委託する",
    "cj":"対処",
    "jj":"前書き",
    "sj":"時間",
    "fx":"方向",
    "jg":"価格",
    "sl":"量",
    "mr":"バイイン",
    "mc":"売る",
    "mp":"买盘",
    "sp":"卖盘",
    "slb":"量",
    "fhsj":"公開時間",
    "fhsl":"リリース数",
    "bps":"白書",
    "gw":"公式ウェブサイト",
    "fz":"min",
    "xs":"hour",
    "tian":"day",
    "zhou":"week",
    "yue":"month",
    "gd":"more",
    "ft":"副图",
    "zt":"主图",
    "sdt":"深度图",
    "zx":"オプション",
    "djck":"クリックして表示"
  },
  "jghy":{
    "jghy":"先物",
    "yxhy":"永久契約",
    "mz":"買い占めます",
    "md":"売買",
    "gmj":"購入金額",
    "jsj":"決済価格",
    "xj":"現在の価格",
    "fx":"方向",
    "sl":"量",
    "jgsj":"納期",
    "gb":"シャットダウン",
    "jxxd":"注文を続ける",
    "cclb":"ポジションリスト",
    "zc":"ホールディング",
    "lscc":"歴史的地位",
    "qblx":"いろんなタイプ",
    "yk":"利益と損失",
    "ddqr":"注文の確認",
    "dqsj":"有効期限",
    "jssj":"決済時間",
    "sy":"所得",
    "tzje":"投資額",
    "zdje":"投資額が0より大きい",
    "kyye":"残高",
    "kyye2":"残高: ",
    "sxf":"費用：",
    "sxfl":"費用",
    "jypz":"名前",
    "jyfx":"取引の方向性",
    "qrxd":"注文を確認する",
    "fs":"more",
    "dqye":"経常収支"
  },
  "zhjl":{
    "title": "資産履歴",
    "cbtb":"出し入れ",
    "jymx":"取引履歴",
    "tgyj":"推广佣金",
    "wwc":"未完成",
    "ywc":"完了"
  },
  "tipsNew":{
    "wjmmts":"確認コードでパスワードを回復する",
    "qscpztp":"バウチャー画像をアップロードしてください",
    "emailgsts":"入力したメールボックスがルールを満たしていない",
    "telgsts":"入力した携帯電話番号の形式が間違っている",
    "lcmmbyz":"パスワードを確認してください",
    "zdsl":"最小数量 ",
    "sldydy":"以上の数量",
    "zxtzsl":"最小数量 ",
    "ddz":"待っています",
    "xs":"小时",
    "min":"最小額 ",
    "max":"最大額 ",
    "yebz":"残高不足です",
    "qsrss":"ロットを入力してください",
    "zdss":"最小ロット",
    "yjj":"拒否されました",
    "shz":"償還",
    "zwkfcz":"この通貨はまだリチャージ可能ではありません",
    "jiaoge": "配達",
    "zhang": "上昇",
    "die": "秋",
   },
   "assets": {
    "total": "資産換算",
    "avaiable": "入手可能",
    "conversion": "変換",
    "canuse": "利用可能",
    "yczc": "アセットを 0 として非表示"
  },
  "status": {
    "statusText": ['失敗','待機中','成功'],
  },
  "langNew2":{
    "zczgz": "総資産",
    "hgx": "コンプライアンス",
    "yszc": "プライバシー ポリシー",
    "gywm": "私たちについて",
    "zb": "AI による定量化",
    "mnjy": "シミュレートされた取引",
    "xbzq": "シンガポール通貨圏",
    "flzq": "報酬ハブ",
    "cjmnzhcg": "デモアカウントの作成に成功しました!",
    "wdzh": "私のアカウント",
    "yymnzhts": "既に仮想アカウントを持っています。再度登録しないでください",
    "tcmnzh": "デモ口座を終了する",
    "mnzhgz": "デモ口座の評価",
    "mnzh": "デモアカウント",
    "ljdzsb": "アドレスに接続できませんでした",
    "ysq": "認可された"
  },
  "c2c":{
    "bt": "P2P",
    "bt2": "P2P決済サービス",
    "cjdd": "注文を作成",
    "mblc": "法定通貨預金",
    "cjydd": "予約注文を作成する",
    "xmjfk": "販売者に支払う",
    "tqhb": "デジタル通貨を出金する",
    "ddzt": "注文ステータス",
    "wdys": "当社の利点",
    "c1": "希望の価格で取引します",
    "c2": "希望の価格で暗号通貨を自由に売買できます。既存のオファーから売買するか、取引広告を作成して理想の価格を設定します。",
    "c3": "低取引手数料",
    "c4": "ピアツーピア (P2P) トランザクションにより、販売者は透明性のある方法で希望の支払い方法を自由に定義でき、銀行振込や現金を含む 700 以上の支払い方法を通じて暗号通貨を売買できます。",
    "c5": "複数の支払い方法",
    "c6": "ピアツーピア (P2P) 取引により、販売者は希望する支払い方法を自由に定義できます。銀行振込、現金を含む 700 以上の支払い方法で暗号通貨を売買できます。",
    "wpp": "一致しません",
    "ypp": "一致しました",
    "ysx": "期限切れ",
    "ddh": "注文番号",
    "mrje": "購入金額",
    "mrbz": "通貨を購入",
    "nssdgj": "国",
    "qsrnssdgj": "国を入力してください",
    "fkrxm": "支払者名",
    "qsrfkrxm": "支払者の名前を入力してください",
    "yx": "メール",
    "qsryx": "メールアドレスを入力してください",
    "mmbz": "購入タイプ",
    "qxzmmbz": "購入タイプを選択してください",
    "qxz": "選択してください",
    "fkfs": "支払い方法",
    "qtxfkfs": "支払い方法を入力してください",
    "zh": "アカウント",
    "fb": "支払い通貨の種類",
    "qtxfb": "支払い通貨の種類を入力してください",
    "ngmdje": "購入金額",
    "qsrje": "金額を入力してください",
    "wxts": "暖かいリマインダー:",
    "dsh": "検討中",
    "ygq": "期限切れ",
    "jcwdwt": "P2P の概要",
    "tjpz": "バウチャーを送信",
    "ckje": "金額の一致",
    "qsrckje": "一致する金額を入力してください",
    "tjzzfb": "コピーを転送",
    "tjjzzm": "IDカード(表面)",
    "tjjzfm": "IDカード(裏面)",
    "psts1": "撮影時は以下の点に注意してください",
    "psts2": "画像の境界線が完全で、フォントが鮮明で、明るさが均一であることに注意してください。",
    "psts3": "名前と一致しない証明写真をアップロードしないでください",
    "qsczzfb": "転送のコピーをアップロードしてください",
    "qscjzzm": "運転免許証の表面をアップロードしてください",
    "qscjzfm": "運転免許証の裏面をアップロードしてください",
    "tj": "送信",
    "je": " 制限範囲",
    "ljtg": "注文する",
    "sp": "DeFi を理解します",
    "xq": "詳細",
    "lxkfppdd": "注文を照合するためにカスタマー サービスに連絡してください",
    "szgj": "国",
    "qsrszgj": "あなたの国を入力してください",
    "fkyhmc": "支払い銀行名",
    "qsrfkyhmc": "支払い銀行名を入力してください",
    "dianhui": "電信送金/国際電信送金",
    "ccsr": "ここに入力してください"
  },
  "xyf":{
    "title": "クレジットスコア",
    "pgsj": "評価時間"
  },
  "bbjy":{
    "mr":"バイイン",
    "mc":"売る",
    "mai":"买",
    "sell":"卖",
    "xj":"制限",
    "sj":"市場価格",
    "pk":"ハンディキャップ",
    "jg":"価格",
    "sl":"量",
    "mrl":"买入量",
    "ss":"量",
    "mcl":"卖出量",
    "ky":"利用可能",
    "km":"買える",
    "ksell":"ホールディング",
    "jye":"取引金額",
    "dqwt":"現在の手数料",
    "lswt":"歴史委員会",
    "jj":"前書き",
    "wtzl":"合計",
    "wtjg":"手数料価格",
    "ycjl":"已成交量",
    "cjjj":"成交均价",
    "cd":"キャンセル",
    "xd":"下单",
    "ywc":"完了",
    "ycd":"キャンセル",
    "wqcj":"完全成交",
    "zx":"オプション",
    "scjg":"市場価格",
    "fhsj":"公開時間",
    "fhsl":"リリース数",
    "bps":"白書",
    "gw":"公式ウェブサイト",
    "qx":"キャンセル",
    "bbjy": "通貨取引"
  },
  "hyjy":{
    "mai":"买",
    "sell":"卖",
    "kc":"ポジションを開く",
    "pc":"清算",
    "cc":"ポジション",
    "kp":"可平",
    "kpc":"平らにすることができます",
    "kcc":"可持仓",
    "kkd":"可开多",
    "kpd":"Pingdoできますか",
    "kkk":"可开空",
    "xj":"制限",
    "sj":"市場価格",
    "xjwt":"指値注文",
    "sjwt":"成行注文",
    "pk":"ハンディキャップ",
    "jg":"価格",
    "sl":"量",
    "gg":"レバー",
    "tzgg":"レバレッジを調整する",
    "ggbs": "レバレッジ",
    "mrl":"买入量",
    "ky":"利用可能",
    "jye":"取引金額",
    "dqwt":"現在の手数料",
    "lswt":"歴史委員会",
    "ptwt":"普通委托",
    "dqwtmr":"現在の注文（購入）",
    "dqwtmc":"現在の注文（販売）",
    "hywt":"合约委托",
    "jj":"前書き",
    "wtzl":"合計",
    "wtjg":"手数料価格",
    "ycjl":"已成交量",
    "cjjj":"成交均价",
    "cd":"キャンセル",
    "xd":"下单",
    "qbcd":"すべての注文をキャンセルする",
    "wqcj":"完全成交",
    "ywc":"完了",
    "ycd":"注文がキャンセルされました",
    "zx":"オプション",
    "scjg":"市場価格",
    "fhsj":"公開時間",
    "fhsl":"リリース数",
    "bps":"白書",
    "gw":"公式ウェブサイト",
    "mrzd":"买入做多",
    "mrpk":"买入平空",
    "mczk":"卖出做空",
    "mcpd":"卖出平多",
    "mrkdkz":"ロングオープン（強気）を買う",
    "mrpkkz":"ショート（強気）を買う",
    "mckkkd":"オープンショート（弱気）を売る",
    "mcpdkd":"フラットロング（弱気）を売る",
    "yxhy":"永久契約",
    "dc":"多仓",
    "kcjj":"开仓均价(BUSDT)",
    "wsxyl":"未实现盈利(BUSDT)",
    "ygqpj":"预估强评价(BUSDT)",
    "syl":"收益率",
    "cwbzj":"仓位保证金(BUSDT)",
    "cw":"仓位(张)",
    "cwjz":"仓位价值(BUSDT)",
    "bzjl":"マージン",
    "kpz":"可平(张)",
    "bdzs":"标的指数",
    "tzbzj":"调整保证金",
    "zyzs":"利益を上げて損失を止める",
    "zjbzj":"增加保证金",
    "jsbzj":"减少保证金",
    "tyhy":"体验合约",
    "ccz":"ポジション(张)",
    "cwbzjt":"仓位保证金(TBTC)",
    "zdzjbzj":"最多增加保证金(TBTC)",
    "zjbzjt":"增加保证金(TBTC)",
    "zhang":"量",
    "qblx":"いろんなタイプ",
    "qb":"全て",
    "ccjg":"ポジション価格",
    "ccsl":"ポジション数",
    "yk":"利益と損失",
    "ccsj":"待ち時間",
    "zy":"止盈",
    "zs":"ストップロス",
    "zje":"合計金額",
    "kcs":"オープンポジションの数",
    "kcjg":"始値",
    "ss":"たくさん",
    "hand":"1ロット=",
    "qx":"キャンセル",
    "qr":"確認"
  },
  "bbjyNew":{
    "jylx": "の種類",
    "jyze": "額"
  },
  "langNew3":{
    "bzxq": "移動レンガの詳細",
     "znbz": "AI 定量的インテリジェント レンガ移動",
     "apits": "世界中の 200 以上の取引所の API にシームレスに接続",
     "jr": "参加",
     "gn": "関数",
     "lhjs": "配当定量化入門",
     "jqrts": "ロボットはどのように動作するのですか?",
     "sctj": "市場統計",
     "scqk": "市況",
     "jiaoge": "配達",
     "zhang": "上昇",
     "die": "落ちる",
     "sz": "設定",
     "qbcp": "すべての製品",
     "jrlh": "AI の定量化に参加する",
    "sywd": "リスクゼロ、安定したリターン",
    "bzbz": "暗号の種類"
  },
  "sztkmm":{
    "title":"トランザクションパスワードを設定する",
    "dlmm":"ログインパスワード",
    "dlmmts":"パスワードを入力してください",
    "xmm":"新密码",
    "mmts":"パスワードの長さ6桁",
    "qrmm":"パスワードを認証する",
    "qr":"確認",
    "qd": "決定する",
    "sztkts": "ヒント：セキュリティセンターにアクセスして、トランザクションパスワードを設定してください"
  },
  "bzhl":{
    "title":"配当金",
    "gz":"ルール",
    "tgdd":"エスクロー注文",
    "zztgdzj":"保管資金",
    "yjjrsy":"毎日の推定値",
    "ljsy":"総収入",
    "tgzdd":"保管中の注文",
    "cljxcp":"戦略的なキャンペーン商品",
    "dbxe":"制限",
    "rsyl":"日次収益率",
    "zq":"注文サイクル",
    "qmr":"行って購入",
    "bbzhzc": "アカウント資産",
    "zcc": "総資産(USDT)",
    "dd":"注文",
    "buy":"購入",
    "jxcp":"注目の製品",
    "ckdd":"注文を確認",
    "gd":"もっと",
    "xzbzts": "シンプルで安全。配当は複数の通貨で選択可能",
    "qtbz": "その他のコイン",
    "dj": "レベル",
    "cjwt": "一般的な問題",
    "ddsl": "注文数量",
    "sl": "金額"
  },
  "bzhlgm":{
    "title":"搬砖获利",
    "bzhld":"搬砖获利得usdt",
    "qtzq":"USDT7天周期",
    "rsyl":"毎日の返品率(%)",
    "lczq":"理财周期",
    "dbxe":"単一の制限 ",
    "pxsj":"配当時間",
    "mr":"毎日",
    "dqfh":"到期返还",
    "tgzj":"エスクロー資金",
    "tqsh":"引き出しと償還",
    "yjsy":"预计收益(USDT)",
    "kyzc":"可用资产(USDT)",
    "cpjs":"製品説明",
    "tgje":"エスクロー金額",
    "qsrtgje":"请输入托管金额",
    "qb":"全て",
    "rm":"ここをクリック",
    "cpzq":"製品寿命",
    "jxr":"计息日",
    "jiexr":"结息日",
    "yjdzr":"预计到账日",
    "gz":"ルールと利益を理解する"
  },
  "bzhlwdtg":{
    "title":"注文状況",
    "tgz":"拘留中",
    "ywc":"完了",
    "ysh":"償還されました",
    "tgje":"預かり金額/預かり時間",
    "rsyl":"毎日戻るネズミ",
    "yhl":"利益を得ました",
    "xdsj":"注文時間",
    "sh":"償還",
    "ddxq":"注文の詳細",
    "ddh":"注文番号 ",
    "syts": "残り",
    "ddztxq": "注文ステータスの詳細"
  },
  "langNew4":{
    "kp": "オープニング",
    "zuoshou": "昨日受け取りました",
    "zg": "最高",
    "zd": "最低",
    "dqjg": "現在の価格",
    "pcjg": "終値",
    "gd": "未決注文",
    "gdj": "未決注文価格",
    "gdjg": "未決注文価格",
    "xfbzj": "必要な保証金: ",
    "ksrfw": "利用可能な入力範囲: ",
    "shou": "ロット",
    "fdjyk": "浮動純損益",
    "pcsl": "決算数量",
    "cx": "取り消す",
    "qrpc": "ポジションを閉じることを確認する",
    "sx": "フィルター",
    "cz": "リセット",
    "zdl": "知っていた",
    "kccg": "ポジションのオープンに成功！",
    "xzfx": "方向を選ぶ",
    "lx": "タイプ",
    "xgcc": "位置を変更する",
    "szzyzs": "ストッププロフィットとストップロスを設定する",
    "szhb": "暗号通貨",
    "gjs": "金属",
    "yy": "原油",
    "jy": "トレード",
    "gp": "ストック",
    "jmhb": "暗号通貨",
    "gdsj": "未決注文時間",
    "gdsl": "未決注文数量",
    "fs": "time"
   },
   "deals":{
    "issue_time":"公開時間",
    "issue_number": "リリース数",
    "white_book": "白書",
    "weburl": "公式ウェブサイト",
    "video_url": "视频介绍",
    "introduction":"前書き",
    "onhand":"1手等于",
    "position": "当前持仓",
    "leverorder":"杠杆下单",
    "leverposition":"杠杆持仓",
    "inputprice":"输入价格",
    "inputmul":"输入倍数",
    "selectmul":"选择倍数",
    "onehand":"1手等于",
    "hand":"交易手数",
    "marketval":"合约市值",
    "bond":"保证金",
    "service":"服务费",
    "balance":"余额",
    "type":"类型",
    "risk":"风险率",
    "total":"持仓总盈亏：",
    "onekey":"一键平仓",
    "makemore":"(做多)",
    "makeless":"(做空)",
    "current":"現在の手数料",
    "all":"全て",
    "weing":"委托中",
    "tding":"交易中",
    "ping":"平仓中",
    "pied":"閉まっている",
    "ceiled":"注文がキャンセルされました",
    "weprice":"委托价",
    "oprice":"开仓价",
    "nowprice":"当前价",
    "zyprice":"止盈价",
    "zsprice":"止损价",
    "canbond":"可用保证金",
    "optime":"开仓时间",
    "pgtime":"平仓时间",
    "znum":"折合数量",
    "gprice":"隔夜费",
    "pcang":"清算",
    "revoke":"キャンセル",
    "fee":"手数料",
    "you":"以当前最优价格交易"
  },
  "zyzs":{
    "title":"利益を上げて損失を止める",
    "zy":"止盈",
    "zs":"ストップロス",
    "qsrzyjg":"テイクプロフィット価格を入力してください",
    "qsrzsjg":"ストップロス価格を入力してください",
    "cfjglx":"トリガー価格タイプ：",
    "zsjg":"指数価格",
    "scjg":"市場価格",
    "pcfs":"クロージング方法：",
    "kpcw":"閉位置",
    "qbcw":"すべてのポジション",
    "wxts":"チップ：",
    "cont": "市場が閉鎖されると、激しい市場変動により成行注文が失敗し、ストッププロフィットとストップロスが成功しない可能性があります。",
    "qr":"確認"
  },
  "ssbt":{
    "ssbt":"税制優遇措置",
    "ssnhm":"社会保障番号",
    "qsrssnhm":"社会保障番号を入力してください",
    "idzmz":"身分証明書の表面写真",
    "qscidzmz":"身分証明書の表面の写真をアップロードしてください",
    "dhfb":"電信送金控え",
    "qscdhfb":"電信送金のコピーをアップロードしてください",
    "srlyfb":"収入源のコピー",
    "qscsrlyfb":"収入源のコピーをアップロードしてください",
  },
  "newReg":{
    "sjh": "携帯電話",
    "yx": "Eメール",
    "yqm": "招待コード",
    "yqm2": "招待コード（オプション）",
    "cjzh": "アカウントを作成する",
    "sysjhzyx": "携帯電話番号/メールで登録",
    "sj": "携帯電話",
    "yhxy": "&lt;ーザー契約&gt;",
    "yhxy2": "およびユ&lt;ーザー契約&gt;を読み、同意します ",
    "hmyzh":"アカウントはまだありませんか？",
    "qzc":"登録に移動",
    "qbdl": "ウォレットへのログイン",
    "qyqbfw": "ウォレットアプリを使用してアクセスしてください",
    "dc": "ログアウト"
  },
  "langNew5":{
    "dl":"ログイン",
    "ljdz":"ウォレットアドレスをリンク",
    "srdz":"アドレスを入力",
    "ljqq":"接続リクエスト",
    "qq":"リクエスト",
    "qb":"ウォレット",
    "ckyehhd":"残高とアクティビティを表示",
    "qqjypz":"取引の承認をリクエスト",
    "cro":"Cronos",
    "jj":"拒否",
    "lj":"接続",
  }
}



// WEBPACK FOOTER //
// ./src/utils/lang/jp.js